import React from 'react'
import PipelineTable from './PipelineTable'
import SearchBox from './SearchBox'
import SearchSelect from './SearchSelect'
import BubbleNotification from './BubbleNotification'
import { FilterButton } from './FilterButton'
import LoanPredictionsQuery from '../smartrate/queries/LoanPredictionsQuery'
import { graphql } from 'react-apollo'

export class PipelineLayout extends React.Component {
  constructor(props) {
    super(props)
    this.pipelineSettings = {
      historyNotifications: [],
      loansNotifications:   [],
      notificationCount:    0,
      order:                'priority',
      showActivity:         false
    }

    this.state = {
      activeTab:          'all',
      auditTab:           this.props.complianceAnalyst ? 'audit_review' : 'rm_review',
      disableSortable:    false,
      sortedAppNumbers:   this.props.loans.map(loan => loan.app_number),
      query:              '',
      persistNotes:       false,
      showAll:            true,
      isDraggable:        false,
      ...this.pipelineSettings,
      ...props
    }
  }
  toggleDraggable = () => {
    this.setState({ isDraggable: !this.state.isDraggable })
  }
  setLocalStorage = (pipelineSettings) => {
    Boolean(this.props.enableEdit) && window.localStorage.setItem('pipelineSettings', JSON.stringify(pipelineSettings))
  }

  updateLocalStorage = (settingsJson) => {
    Boolean(settingsJson) && window.localStorage.setItem('pipelineSettings', JSON.stringify(settingsJson))
  }

  toggleActivity = () => {
    this.setState({ showActivity: !this.state.showActivity, persistNotes: !this.state.showActivity })
    this.sortLoans(this.state.order)
  }

  sortByKey = (key, ascending) => {
    const { loans } = this.state
    const loanStates = {
      pending_approval: 0,
      started: 1,
      prequalified: 2,
      conditionally_approved: 3,
      '4506t_results_uploaded': 4,
      customer_forms_uploaded: 5,
      ready_for_etran: 6,
      etran_verified: 7,
      forms_to_be_verified: 8,
      forms_verified: 9,
      credit_memo_entered: 10,
      loandoc_generated: 11,
      loandoc_completed: 12,
      loandoc_customer_received_need_signatures: 13,
      signatures_checked_and_uploaded: 14,
      boarded: 15,
      funded: 16,
      pending_declined: 17,
      declined: 18,
      withdrawn: 20,
      expired: 21
    }
    const stateIndex = (loan) => loanStates[loan.state.split(' ').join('_').toLowerCase()]
    let sortedLoans = loans

    switch (key) {
      case 'amount':
        sortedLoans = loans.sort((a, b) =>
          ascending ? a.amount - b.amount : b.amount - a.amount
        )
        break
      case 'audit_handed_off_at':
        const auditLoans    = loans.filter(loan => Boolean(loan.audit_handed_off_at))
        const notAuditLoans = loans.filter(loan => Boolean(!loan.audit_handed_off_at))
        sortedLoans = auditLoans.sort((a, b) =>
          ascending
            ? Date.parse(a.audit_handed_off_at.split(' ')[0]) < Date.parse(b.audit_handed_off_at.split(' ')[0])
            : Date.parse(a.audit_handed_off_at.split(' ')[0]) > Date.parse(b.audit_handed_off_at.split(' ')[0])
        ).concat(notAuditLoans) // Concat the rest of the loans so we don't truncate loans in the state
        break
      case 'company_name':
        sortedLoans = loans.sort((a, b) =>
          ascending
            ? a.company_name.charCodeAt(0) - b.company_name.charCodeAt(0)
            : b.company_name.charCodeAt(0) - a.company_name.charCodeAt(0)
        )
        break
      case 'days_since_assigned':
        sortedLoans = loans.sort((a, b) =>
          ascending ? a.days_since_assigned - b.days_since_assigned : b.days_since_assigned - a.days_since_assigned
        )
        break
      case 'partner_name':
        sortedLoans = loans.sort((a, b) =>
          ascending
            ? a.partner_name.charCodeAt(0) - b.partner_name.charCodeAt(0)
            : b.partner_name.charCodeAt(0) - a.partner_name.charCodeAt(0)
        )
        break
      case 'state':
        sortedLoans = loans.sort((a, b) =>
          ascending ? stateIndex(a) - stateIndex(b) : stateIndex(b) - stateIndex(a)
        )
        break
      case 'product':
        sortedLoans = loans.sort((a, b) =>
          ascending
            ? a.product_short_name.charCodeAt(0) - b.product_short_name.charCodeAt(0)
            : b.product_short_name.charCodeAt(0) - a.product_short_name.charCodeAt(0)
        )
        break
      case 'active_items':
        const loansWithoutTodos = loans.filter(loan => loan.active_items !== null)
        const loansWithTodos = loans
          .filter(loan => loan.active_items === null)
          .sort((a, b) => ascending ? a.active_items > b.active_items : a.active_items < b.active_items)
        sortedLoans = ascending ? loansWithTodos.concat(loansWithoutTodos) : loansWithoutTodos.concat(loansWithTodos)
        break
    }
    this.setState({ loans: sortedLoans })
  }

  sortLoans = (order) => {
    const { loans } = this.state
    let sortedLoans = []
    switch (order) {
      case 'priority':
        const priorityLevels = {
          blue:   0,
          green:  1,
          orange: 2,
          red:    3,
          alpha:  4
        }
        sortedLoans = loans.sort((a, b) => priorityLevels[a.priority] - priorityLevels[b.priority])
        this.setState({ isDraggable: false })

        break
      case 'recent_activity':
        const loansSansNotifications = []
        for (const loan of loans) {
          const dates = loan.notifications.map(notification => parseInt(notification.date, 10))
          if (dates.length === 0) {
            loansSansNotifications.push(loan)
          } else {
            loan.maxDate = dates.reduce((a, b) => Math.max(a, b))
            sortedLoans.push(loan)
          }
          this.setState({ isDraggable: false })
        }
        sortedLoans = sortedLoans.sort((a, b) => b.maxDate - a.maxDate).concat(loansSansNotifications)
        break
      case 'my_action_items':
        const loansWithTodos    = loans.filter(loan => loan.active_items !== null)
        const loansWithoutTodos = loans.filter(loan => loan.active_items === null)
        sortedLoans = loansWithTodos.sort(
          (a, b) => a.active_items.charAt(0).toLowerCase() > b.active_items.charAt(0).toLowerCase()
        ).concat(loansWithoutTodos)
        this.setState({ isDraggable: false })
        break
      case 'custom_sort':
        const customOrder = JSON.parse(localStorage.getItem('customList'))
        if (customOrder) {
          const newLoans = []
          let newList = []
          for (const loan of loans) {
            if (!customOrder.includes(loan.id)) {
              newLoans.push(loan)
            }
          }
          newList = customOrder.map((customId) => loans.find((l) => l.id === customId)).filter((e) => e)
          sortedLoans = newLoans.concat(newList)
        } else {
          sortedLoans = loans
        }
        this.setState({ isDraggable: true })
        break
    }
    if (sortedLoans.length === 0) {
      this.setState({ loans: this.props.loans, order })
    } else {
      this.setState({ loans: sortedLoans, order })
    }
    const storedSettings = JSON.parse(localStorage.getItem('pipelineSettings'))
    if (storedSettings) {
      storedSettings.order = order
      this.setLocalStorage(storedSettings)
    }
  }

  updateNotifications = (loans) => {
    let oldLoans = []
    const newLoans = []
    let { loansNotifications } = this.state
    let { notificationsCount } = this.state
    let result
    if (this.state.historyNotifications.length == 0) {
      this.state.loans.map(loan => {
        oldLoans.push({
          app_number: loan.app_number,
          notification_ids: loan.notifications.map(notification => {
            notification.id
          })
        })
      })
    } else {
      oldLoans = this.state.historyNotifications
    }
    loans.map(function(loan) {
      newLoans.push({
        app_number: loan.app_number,
        notification_ids: loan.notifications.map(notification => {
          notification.id
        })
      })
    })
    newLoans.forEach(loan => {
      result = oldLoans.find(ol => ol.app_number === loan.app_number)
      let differences = []
      if (result) {
        differences = loan.notification_ids.filter(id => result.notification_ids.includes(id))
      }
      if (differences.length > 0) {
        loansNotifications.push(loan.app_number)
      }
    })
    loansNotifications = [...new Set(loansNotifications)]
    notificationsCount = loansNotifications.length
    if (this.state.activeTab !== 'all') {
      notificationsCount = 0
    }
    this.setState({
      loansWithNotifications: loansNotifications,
      notificationsNumber: notificationsCount,
      loansHistoryNotifications: newLoans
    })
    /// Setting localStorage
    this.setLocalStorage(
      {
        order: this.state.order,
        showActivity: this.state.showActivity,
        notificationsNumber: notificationsCount
      }
    )
    // update loans after compare
    // if (loansWithNotifications.length > 0 ) this.updateLoansfromDataBase(newLoans)
  }

  cleanLoansNotifications = () => {
    const archivedNotifications = []
    this.state.loans.forEach(loan => {
      archivedNotifications.push({
        app_number: loan.app_number,
        notification_ids: loan.notifications.map(notification => {
          notification.id
        })
      })
    })
    this.setState({ loansNotifications: [], historyNotifications: archivedNotifications, notificationsCount: 0 })
  }

  doSearch = (query) => {
    let result = []
    query = query.toLowerCase()
    const searchFunction = (loan, query) => {
      const searchString = []
      searchString.push(
        loan.app_number.toString(),
        loan.amount.toString(),
        loan.company_name.toLowerCase(),
        loan.borrower_name.toLowerCase(),
        loan.partner_name.toLowerCase(),
        loan.lender_name.toLowerCase(),
        loan.state.toLowerCase()
      )
      if (loan.active_items !== null) {
        searchString.push(loan.active_items.toLowerCase())
      }
      return searchString.toString().includes(query)
    }
    result = this.state.loans.filter(loan => searchFunction(loan, query))
    if (query == '') {
      this.setState({ query, loans: this.props.loans })
    } else {
      this.setState({ query, loans: result })
    }
  }

  changeTableState = (newState) => {
    if (newState.activeTab === 'activity') {
      this.setState({ showActivity: true })
    } else if (!this.state.persistNotes) {
      this.setState({ showActivity: false })
    }
    this.setState(newState)
    this.sortLoans(this.state.order)
  }

  componentWillMount = () => {
    // Use settings from local storage if available
    const storedSettings = window.localStorage.getItem('pipelineSettings')
    const settingsJson = JSON.parse(storedSettings) || { }
    let order
    if (!settingsJson) {
      this.sortLoans(this.state.order)
      settingsJson.order = order
    } else {
      this.sortLoans(settingsJson.order)
    }
    this.updateLocalStorage(settingsJson)
  }

  componentDidMount = () => {
    this.sortLoans(this.state.order)
    this.props.enableEdit && this.updateNotifications(this.props.loans)
  }

  render() {
    const { loading, latestPredictionsForLoans, loans: loansData } = this.props.data
    const {
      activeTab,
      auditTab,
      complianceAnalyst,
      currentAdmin,
      customerService,
      enableEdit,
      loans,
      notificationCount,
      order,
      showActivity,
      query,
      isDraggable
    } = this.state
    const switchAllTable     = () => {
      this.changeTableState({ activeTab: 'all' })
    }
    const switchAuditTable   = () => {
      this.changeTableState({ activeTab: 'audit' })
    }
    const switchActivityFeed = () => {
      this.changeTableState({ activeTab: 'activity', notificationsCount: 0 })
    }
    const switchAuditReview  = () => {
      this.changeTableState({ auditTab: 'audit_review' })
    }
    const switchRmReview     = () => {
      this.changeTableState({ auditTab: 'rm_review' })
    }
    const switchApproved     = () => {
      this.changeTableState({ auditTab: 'approved' })
    }
    const auditLoans = loans.filter(loan =>
      complianceAnalyst ? Boolean(loan.audit_handed_off_at) : Boolean(loan.audit_handed_off_at) && loan.admin_id == currentAdmin
    )
    const auditReviewLoans = auditLoans.filter(loan => Boolean(loan.audit_review))
    const rmReviewLoans    = auditLoans.filter(loan => Boolean(loan.rm_review))
    const approvedLoans    = auditLoans.filter(loan => Boolean(loan.approved))
    const auditLoanCount   = auditLoans.length
    const allLoanCount     = loans.length
    const auditReviewCount = auditReviewLoans.length
    const rmReviewCount    = rmReviewLoans.length
    const approvedCount    = approvedLoans.length
    let displayedLoans

    if (activeTab === 'audit') {
      switch (auditTab) {
        case 'audit_review':
          displayedLoans = auditReviewLoans
          break
        case 'rm_review':
          displayedLoans = rmReviewLoans
          break
        case 'approved':
          displayedLoans = approvedLoans
          break
        default:
          displayedLoans = auditLoans
          break
      }
    } else {
      displayedLoans = loans
    }

    return (
      <section>
        <div className='row-fluid'>
          <div className='span6'>
            <nav>
              <a
                className={activeTab === 'all' ? 'active' : undefined}
                onClick={switchAllTable}
              >
                All Loans ({allLoanCount})
              </a>
              <span className='separator'> | </span>
              <a
                className={activeTab === 'audit' ? 'active' : undefined}
                onClick={switchAuditTable}
              >
                SB Audit ({auditLoanCount})
              </a>
              <span className='separator'> | </span>
              <a
                className={activeTab === 'activity' ? 'active' : undefined}
                onClick={switchActivityFeed}
              >
                Activity Feed
              </a>
              <BubbleNotification
                loans={loans}
                currentAdmin={currentAdmin}
                notificationCount={notificationCount}
                enableEdit={enableEdit}
              />
            </nav>
          </div>
          <div className='span6 push-text-right'>
            <br />
            <SearchBox query={query} doSearch={this.doSearch} />
            <FilterButton />
          </div>
          { activeTab === 'audit' &&
            <div className='span12'>
              <nav className='indent-text-left'>
                <a className={auditTab === 'audit_review' ? 'active' : undefined} onClick={switchAuditReview}>
                  Audit Review ({auditReviewCount})
                </a>
                <span className='separator'>|</span>
                <a className={auditTab === 'rm_review' ? 'active' : undefined} onClick={switchRmReview}>
                  RM Review ({rmReviewCount})
                </a>
                <span className='separator'>|</span>
                <a className={auditTab === 'approved' ? 'active' : undefined} onClick={switchApproved}>
                  Approved ({approvedCount})
                </a>
              </nav>
            </div>
          }
        </div>
        { activeTab !== 'activity' &&
            <SearchSelect
              order={order}
              sortLoans={this.sortLoans}
              showActivity={showActivity}
              toggleActivity={this.toggleActivity}
            />
        }
        <div className="row-fluid">
          <div className="span12">
            <PipelineTable
              latestPredictionsForLoans={latestPredictionsForLoans}
              loansData={loansData}
              loading={loading}
              loans={displayedLoans}
              csrfToken={this.props.csrfToken}
              complianceAnalyst={complianceAnalyst}
              customerService={customerService}
              currentAdmin={currentAdmin}
              enableEdit={enableEdit}
              order={order}
              isDraggable={isDraggable}
              activeTab={activeTab}
              showActivity={showActivity}
              sortByKey={this.sortByKey}
              sortLoans={this.sortLoans}
              toggleDraggable={this.toggleDraggable}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default graphql(LoanPredictionsQuery, {
  options: OwnProps => ({
    variables: {
      loanIds: OwnProps.loans.map(loan => loan.id)
    }
  })
})(PipelineLayout)
